import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-lg text-center text-gray-500 border-b border-gray-400" }
const _hoisted_2 = { class: "flex flex-wrap -mb-px" }
const _hoisted_3 = { class: "mr-4" }
const _hoisted_4 = { class: "mr-4" }
const _hoisted_5 = { class: "mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePage(0))),
          class: _normalizeClass(["inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-500 cursor-pointer", _ctx.getActivePage(0)])
        }, "Lekkernijen", 2)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePage(1))),
          class: _normalizeClass(["inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-500 cursor-pointer", _ctx.getActivePage(1)])
        }, "Pakketten", 2)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePage(2))),
          class: _normalizeClass(["inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-600 cursor-pointer", _ctx.getActivePage(2)])
        }, "Team", 2)
      ])
    ])
  ]))
}